// Muzzle: the mandatory blaze-orange tip (toy.blaze, #fe6a00), flat (no shading, so the whole socket reads
// as blaze) and outlined in the barrel's outline colour so no blaze-hued outline leaks onto the body.
import type { Part } from '../../passes.ts';
import type { Pt } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

export interface Muzzle {
  part: Part;
  /** The socket polygon (the tip's fill rect) in gu. */
  socket: Pt[];
}

export function muzzle(g: GunKit): Muzzle {
  const { x, len } = g.r.barrel;
  const { len: tl, th } = g.r.muzzle;
  const x0 = x + len;
  const p = lrect(g, g.pal.blazeTok, x0, -th / 2, tl, th, 2.2, {
    flat: true,
    outline: g.pal.sw(g.r.second).outline,
  });
  return {
    part: p,
    socket: [
      [x0, -th / 2],
      [x0 + tl, -th / 2],
      [x0 + tl, th / 2],
      [x0, th / 2],
    ],
  };
}
